import * as S from './LTRow.styled';

type Props = {
    children: React.ReactNode;
    style?: React.CSSProperties;
    flexStart?: boolean;
    innerStyle?: React.CSSProperties;
};

const LTRow = ({ children, style, flexStart, innerStyle }: Props) => {
    return (
        <S.OuterDiv>
            <S.InnerDiv
                flexStart={flexStart ? flexStart : false}
                style={{ ...style, ...innerStyle }}
            >
                {children}
            </S.InnerDiv>
        </S.OuterDiv>
    );
};

export { LTRow };
